import image from '../img/blank-image.svg';

export const blankImage = image;
